// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"89ec941b","43":"a442309b","164":"dd1d5e60","249":"83eb3349","543":"2ce07467","787":"b2c3f5bb","834":"d654e807"}[chunkId] + ".chunk.js";
};